export default function CTASection() {
  return (
    <section id="cta" className="relative w-full flex flex-col lg:flex-row min-h-[420px] md:min-h-[500px]">
      {/* Left Side - Image with Overlay */}
      <div className="relative flex-1 min-h-[320px] md:min-h-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Fashion%20ecommerce%20unboxing%20moment%20hands%20holding%20open%20white%20box%20with%20colorful%20streetwear%20clothing%20items%20peeking%20out%2C%20warm%20natural%20window%20light%2C%20cream%20and%20soft%20beige%20tones%2C%20lifestyle%20product%20photography%2C%20authentic%20candid%20moment%2C%20cozy%20home%20setting%20with%20textile%20textures%2C%20aspirational%20shopping%20experience%2C%20elevated%20casual%20aesthetic&width=960&height=700&seq=cta-main-v2&orientation=landscape"
          alt="CSSBuy Spreadsheet - Comece Agora"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/25"></div>
        <div className="absolute bottom-0 left-0 p-10 md:p-14">
          <span className="text-white/70 text-xs font-medium mb-3 block">CSSBuy Info</span>
          <h2 className="text-white font-heading font-bold text-3xl md:text-5xl leading-tight">
            Compre os<br />
            melhores<br />
            <span className="font-normal">produtos agora</span>
          </h2>
        </div>
      </div>

      {/* Right Side - Content */}
      <div className="flex-1 bg-background-50 flex flex-col items-center justify-center py-14 px-6 md:px-14">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 text-center leading-tight mb-4">
          Comece a comprar<br />
          com segurança
        </h2>
        <p className="text-foreground-600 text-sm md:text-base text-center max-w-md leading-relaxed mb-8">
          Comece agora e descubra os melhores produtos do CSSBuy Spreadsheet. Acesso gratuito, links verificados e atualizações diárias.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="group inline-flex items-center gap-2 bg-primary-500 text-white font-semibold px-10 py-4 rounded-full whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer text-sm"
        >
          Acessar Kaspreadsheet
          <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}